module.exports = __webpack_public_path__ + "assets/cd82598858fb809291ed42e8fc459b4d.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/EffectDuring3.mp3
 ** module id = 349
 ** module chunks = 0
 **/